/**
 * Block Registration
 *
 * 모든 블록 컴포넌트를 레지스트리에 등록
 * 이 파일은 BlockRenderer에서 자동으로 import되어 실행됨
 */

import { registerBlocks } from '@/shared/lib/block-registry.tsx';
// Interactive blocks
import { AccordionBlock } from './AccordionBlock';
import { ArticleBlock } from './ArticleBlock';
import { ArticleListBlock } from './ArticleListBlock';
import { BadgeBlock } from './BadgeBlock';
import { BulletListBlock } from './BulletListBlock';
// Data blocks
import { CardBlock } from './CardBlock';
import { CategoryBadgeBlock } from './CategoryBadgeBlock';
import { CreatorInfoBlock } from './CreatorInfoBlock';
import { DividerBlock } from './DividerBlock';
import { FAQAccordionBlock } from './FAQAccordionBlock';
import { GridBlock } from './GridBlock';
// Content blocks
import { HeadingBlock } from './HeadingBlock';
import { HeroImageBlock } from './HeroImageBlock';
import { IconBlock } from './IconBlock';
import { ImageBlock } from './ImageBlock';
import { KeyValueBlock } from './KeyValueBlock';
import { LinkButtonBlock } from './LinkButtonBlock';
// News blocks
import { NewsListBlock } from './NewsListBlock';
// Layout blocks
import { RowBlock } from './RowBlock';
import { SectionBlock } from './SectionBlock';
import { StatBlock } from './StatBlock';
import { StatGroupBlock } from './StatGroupBlock';
import { TableBlock } from './TableBlock';
import { TagListBlock } from './TagListBlock';
import { TechStackBlock } from './TechStackBlock';
import { TextBlock } from './TextBlock';
import { TimelineBlock } from './TimelineBlock';
import { TranscriptBlock } from './TranscriptBlock';
// Media blocks
import { VideoInfoBlock } from './VideoInfoBlock';

/**
 * 모든 블록 컴포넌트를 레지스트리에 등록
 */
registerBlocks({
  // Layout blocks
  row: {
    component: RowBlock,
    displayName: 'RowBlock',
    category: 'layout',
  },
  section: {
    component: SectionBlock,
    displayName: 'SectionBlock',
    category: 'layout',
  },
  grid: {
    component: GridBlock,
    displayName: 'GridBlock',
    category: 'layout',
  },
  divider: {
    component: DividerBlock,
    displayName: 'DividerBlock',
    category: 'layout',
  },

  // Content blocks
  heading: {
    component: HeadingBlock,
    displayName: 'HeadingBlock',
    category: 'content',
  },
  text: {
    component: TextBlock,
    displayName: 'TextBlock',
    category: 'content',
  },
  'bullet-list': {
    component: BulletListBlock,
    displayName: 'BulletListBlock',
    category: 'content',
  },
  image: {
    component: ImageBlock,
    displayName: 'ImageBlock',
    category: 'content',
  },
  'hero-image': {
    component: HeroImageBlock,
    displayName: 'HeroImageBlock',
    category: 'content',
  },
  'creator-info': {
    component: CreatorInfoBlock,
    displayName: 'CreatorInfoBlock',
    category: 'content',
  },
  'category-badge': {
    component: CategoryBadgeBlock,
    displayName: 'CategoryBadgeBlock',
    category: 'content',
  },
  badge: {
    component: BadgeBlock,
    displayName: 'BadgeBlock',
    category: 'content',
  },
  icon: {
    component: IconBlock,
    displayName: 'IconBlock',
    category: 'content',
  },

  // Data blocks
  card: {
    component: CardBlock,
    displayName: 'CardBlock',
    category: 'data',
  },
  'key-value': {
    component: KeyValueBlock,
    displayName: 'KeyValueBlock',
    category: 'data',
  },
  'tag-list': {
    component: TagListBlock,
    displayName: 'TagListBlock',
    category: 'data',
  },
  stat: {
    component: StatBlock,
    displayName: 'StatBlock',
    category: 'data',
  },
  'stat-group': {
    component: StatGroupBlock,
    displayName: 'StatGroupBlock',
    category: 'data',
  },
  table: {
    component: TableBlock,
    displayName: 'TableBlock',
    category: 'data',
  },
  timeline: {
    component: TimelineBlock,
    displayName: 'TimelineBlock',
    category: 'data',
  },
  article: {
    component: ArticleBlock,
    displayName: 'ArticleBlock',
    category: 'data',
  },
  'article-list': {
    component: ArticleListBlock,
    displayName: 'ArticleListBlock',
    category: 'data',
  },
  'tech-stack': {
    component: TechStackBlock,
    displayName: 'TechStackBlock',
    category: 'data',
  },

  // Interactive blocks
  accordion: {
    component: AccordionBlock,
    displayName: 'AccordionBlock',
    category: 'interactive',
  },
  'faq-accordion': {
    component: FAQAccordionBlock,
    displayName: 'FAQAccordionBlock',
    category: 'interactive',
  },
  'link-button': {
    component: LinkButtonBlock,
    displayName: 'LinkButtonBlock',
    category: 'interactive',
  },

  // Media blocks
  'video-info': {
    component: VideoInfoBlock,
    displayName: 'VideoInfoBlock',
    category: 'media',
  },
  transcript: {
    component: TranscriptBlock,
    displayName: 'TranscriptBlock',
    category: 'media',
  },

  // News blocks
  'news-list': {
    component: NewsListBlock,
    displayName: 'NewsListBlock',
    category: 'data',
  },
});

// 등록 완료 로그 (개발 환경에서만)
if (process.env.NODE_ENV === 'development') {
  console.log('[BlockRegistry] Registered 27 block components');
}
